import { performanceApi as api } from "./apiClient.tsx";

import {
  CatalogPage,
  CatalogRecord,
  ChillerComponents,
  Fields,
  ResourceName,
} from "../components/CatalogAdmin/CatalogAdmin.types.tsx";

export async function listRecords<T = Fields>(
  resource: ResourceName,
  search: string,
  page: number,
  pageSize: number
): Promise<CatalogPage<T>> {
  const { data } = await api.get(`/catalog/${resource}`, {
    params: { search: search || undefined, page, page_size: pageSize },
  });

  return data;
}

export async function getRecord<T = Fields>(
  resource: ResourceName,
  id: number
): Promise<CatalogRecord<T>> {
  const { data } = await api.get(`/catalog/${resource}/${id}`);

  return data;
}

export async function createRecord<T = Fields>(
  resource: ResourceName,
  fields: T
): Promise<CatalogRecord<T>> {
  const { data } = await api.post(`/catalog/${resource}`, fields);

  return data;
}

export async function updateRecord<T = Fields>(
  resource: ResourceName,
  id: number,
  fields: T
): Promise<CatalogRecord<T>> {
  const { data } = await api.put(`/catalog/${resource}/${id}`, fields);

  return data;
}

export async function deleteRecord(resource: ResourceName, id: number): Promise<void> {
  await api.delete(`/catalog/${resource}/${id}`);
}

export async function importCsv(resource: ResourceName, file: File): Promise<number> {
  const form = new FormData();
  form.append("file", file);

  const { data } = await api.post(`/catalog/${resource}/import`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return data.created;
}

export async function getChillerComponents(): Promise<ChillerComponents> {
  const { data } = await api.get("/catalog/chillers/components");

  return data;
}
